import { defineNuxtPlugin, useRuntimeConfig } from '#app';
import posthog from 'posthog-js';
import { usePostHog } from '~/composables/usePostHog';

const detectIsLikelyUS = (): boolean => {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const language = navigator.language || navigator.languages?.[0];
    const isLikelyUS =
      timeZone?.startsWith('America/') && language?.includes('en-US');
    return Boolean(isLikelyUS);
  } catch {
    return false;
  }
};

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const posthogApiKey = config.public.posthogApiKey || '';
  const posthogHost = config.public.posthogHost || 'https://us.i.posthog.com';

  // Only initialize if API key is present
  if (posthogApiKey) {
    posthog.init(posthogApiKey, {
      api_host: posthogHost,
      capture_pageview: false, // We'll handle this manually for more control
      persistence: detectIsLikelyUS() ? 'localStorage' : 'memory',
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
    });

    // Initialize the composable with the PostHog instance
    const { init } = usePostHog();
    init(posthog);
  }

  // Make PostHog available throughout the app
  nuxtApp.provide('posthog', posthog);

  // PostHog is now properly configured
});
